var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "14px",
    viewBox: "0 0 12 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "delete.1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Space-Fix",
    transform: "translate(-1139.000000, -19.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(1139.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete.1",
    transform: "translate(-0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.84,2.66 L10.36,2.66 L10.36,2.24 L7.88088,2.24 L7.33565,1.149561 C7.2408,0.95984 7.04683,0.84 6.83473,0.84 L4.36527,0.84 C4.153135,0.84 3.959228,0.95984 3.864371,1.149561 L3.319148,2.24 L0.84,2.24 L0.84,2.66 Z M11.2,3.5 L0,3.5 L0,2.1 C0,1.713404 0.313404,1.4 0.7,1.4 L2.8,1.4 L3.113047,0.773899 C3.3502,0.2996 3.834964,0 4.36527,0 L6.83473,0 C7.36505,0 7.8498,0.2996 8.08696,0.773899 L8.4,1.4 L10.5,1.4 C10.88661,1.4 11.2,1.713404 11.2,2.1 L11.2,3.5 Z M10.5,4.2 L0.7,4.2 L0.7,12.6 C0.7,13.37322 1.326801,14 2.1,14 L9.1,14 C9.87322,14 10.5,13.37322 10.5,12.6 L10.5,4.2 Z M9.66,5.04 L9.66,12.6 C9.66,12.90926 9.40926,13.16 9.1,13.16 L2.1,13.16 C1.790719,13.16 1.54,12.90926 1.54,12.6 L1.54,5.04 L9.66,5.04 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.72c1f693.svg";
export { ForwardRef as ReactComponent };